import { Component } from '@theme/component';

class HairtecCookiePreferences extends Component {
  #timer;
  #attempts = 0;
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.#attempts = 0;
    this.#detect();
    window.addEventListener('load', this.#detect, { signal: this.#controller.signal });
    document.addEventListener('visitorConsentCollected', this.#detect, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.#timer);
    this.#controller?.abort();
  }

  #detect = () => {
    clearTimeout(this.#timer);
    if (typeof window.privacyBanner?.showPreferences === 'function') {
      this.hidden = false;
      return;
    }
    if (this.#attempts++ < 40) this.#timer = setTimeout(this.#detect, 250);
  };

  async showPreferences() {
    const api = window.privacyBanner;
    const button = this.refs.button;
    if (typeof api?.showPreferences !== 'function' || !(button instanceof HTMLButtonElement)) return;
    button.disabled = true;
    if (this.refs.message) this.refs.message.textContent = '';
    try {
      await api.showPreferences();
    } catch {
      if (this.isConnected && this.refs.message) this.refs.message.textContent = this.dataset.error || '';
    } finally {
      if (this.isConnected) button.disabled = false;
    }
  }
}

if (!customElements.get('hairtec-cookie-preferences')) {
  customElements.define('hairtec-cookie-preferences', HairtecCookiePreferences);
}
